import React, { Component } from 'react';

import { BrowserRouter, Route } from "react-router-dom";
import { Link } from "react-router-dom";

import Header from './components/Header';
import Footer from './components/Footer';

import Home from './components/Home';
import Download from './components/Download';
import Term from './components/Term';
import Search from './components/Search';

import Table from 'react-bootstrap/Table';
import { Stage, ColormakerRegistry } from 'ngl';
import GA from './utils/GoogleAnalytics'

import './App.css';
import './config.js';

const restServer = global.restServer;

/* this is also in Term.css */
const colourMap = {
  "domain-scop"   : "#E59749",
  "domain-pdb"    : "white",
  "domain-chain"  : "skyblue",
  "uniprot"       : '#3666D1',
  "domain-sf"     : '#6B8E23',
  "domain-fa"     : '#53B8B1'
} ;

class App extends Component {
  search_results:Object;

  constructor(props) {
    super(props);
    this.onSearchDone = this.onSearchDone.bind(this);
    this.state = {search_results: null};
  }
  onSearchDone(results) {
    this.setState({ search_results: results});
    this.render(1);
  }

  render() {
    //https://medium.com/@svinkle/how-to-deploy-a-react-app-to-a-subdirectory-f694d46427c1
  return (
    <div className="App">
      <BrowserRouter>
        { GA.init() && <GA.RouteTracker /> }

        <Header onSearchDone={this.onSearchDone} searchResults={this.state.search_results}/>
        <Route exact path={`${process.env.PUBLIC_URL}/`} component={Home} />
        <Route path={`${process.env.PUBLIC_URL}/about`} component={About} />
        <Route path={`${process.env.PUBLIC_URL}/contact`} component={Contact} />
        <Route path={`${process.env.PUBLIC_URL}/download`} component={Download} />
        <Route path={`${process.env.PUBLIC_URL}/search`} component={Search} searchResults={this.state.search_results}/>
        <Route path={`${process.env.PUBLIC_URL}/term/:termId`} component={Term} />
        <Route path={`${process.env.PUBLIC_URL}/stats`} component={Stats} />
        <Route path={`${process.env.PUBLIC_URL}/sview/:termId`} component={SView} /> 
     <Footer/>
      </BrowserRouter>
     </div>
  );
  }
}

export default App;

class SView extends Component {
  constructor(props) {
    super(props);
    const repDomain = {
      scopDomains: [
          { 
              chain: "G",
              segments: ["8-109", "236-301", "400-438"]
          }
      ],
      PDBId : '2BCG'
    };

    this.state = {
      pdbId : repDomain.PDBId,
      scopDomains: repDomain.scopDomains,
      data: {}
    };  
  }
  componentDidMount() {
    const termId =  this.props.match.params.termId;
    const url = [restServer, 'representative_structure', termId].join("/");
    fetch(url)
    .then(response => response.json())
    .then(data => { this.setState({data: data, termId: termId})}); 
  }

  render() {
    if (this.state.data) {
      let structure = this.state.data.structure;
      if (structure) {
        const pdbID = structure[0].pdb_code;
        let dhash = structure.reduce( (p, n) => {
          let chain = n.pdb_chain;
          if (p[chain]) {
              p[chain].push(n.pdb_begin + '-' + n.pdb_end);
          } else {
              p[chain] = [n.pdb_begin + '-' + n.pdb_end];
          }
          return p;
        }, {});

        let segments = Object.keys(dhash).map( (k) => {
          return {'chain': k, 'segments': dhash[k]};
        });
        return (
          <StructureViewer PDBId={pdbID} selectedResidues={segments}/>
        )
      }
    }
    return (<> No representative structure found </>);
  }
}
 
class StructureViewer extends Component {
  /* Arguments:
      PDBId : pdb domain id, 
          e.g 2BCG
      selectedResidues : array of the residues to select, 
          e.g [
              { 
                  chain: "A",
                  segments: ["1-10","10-30"]
              }
          ]
  */
  constructor(props) {
      super(props);
      this.state = {
          props: props
      };
  }

  componentDidMount() {
      const script = document.createElement("script");
      script.src = "https://cdn.rawgit.com/arose/ngl/v0.10.4-1/dist/ngl.js";
      script.async = true;
      document.body.appendChild(script);

      let pdbid = this.props.PDBId;
//      console.log(pdbid);
      let selectedResidues = this.props.selectedResidues || [];
  
      var stage = new Stage("ngl");
      stage.setParameters({
          backgroundColor: "#F0F0F0"
      });

      let selectionScheme = selectedResidues.map( (o) => {
          return [ colourMap["domain-scop"], (':' + o.chain + ' and (' + o.segments.join(' or ') + ')')];
      });
      
      selectedResidues.map( (o, index) => {
          selectionScheme.push([ colourMap["domain-chain"], (':' + o.chain)]);
          return index;
      });
      
      selectionScheme.push( [colourMap["domain-pdb"], "*"] );
//      console.log(selectionScheme);

      const selectResidues = ColormakerRegistry.addSelectionScheme(selectionScheme, "SCOP Domains");
      stage.loadFile("rcsb://"+pdbid).then(function(o) {
          console.log('loaded ' , pdbid);
          o.addRepresentation("cartoon", {color: selectResidues });  // pass schemeId here        
          o.autoView();
      });
      window.addEventListener( "resize", function( event ){ 
          stage.handleResize();
      }, false );
  }

  render() {
      return (<div id="ngl">
          <div className="ngl-colour-legend">
              <div> <span className="domain-scop"> &nbsp; </span> Domain only</div>
              <div> <span className="domain-chain"> &nbsp; </span> Domain in chain</div>
              <div> <span className="domain-pdb"> &nbsp; </span> Domain in PDB</div>
          </div>            
      </div>)
  }
}

function About() {
  return (
    <div className="page-content">
    <div className="page-title">About</div>
    <div className="page-section">
      <div className="help-section">Database description.</div>
<p>The SCOP database aims to provide a detailed and comprehensive description of the structural and evolutionary relationships between proteins whose three-dimensional structure is known and deposited in the Protein Data Bank. The main levels of the classification are:</p>
<p><span className="cl-level">Family</span> groups closely related proteins with a clear evidence for their evolutionary origin. In most cases, their relationship is detectable with current sequence comparison methods, e.g. BLAST, PSI- BLAST, HMMER.</p>
<p><span className="cl-level">Superfamily</span> brings together more distantly related protein domains. Their similarity is frequently limited to common structural features that along with a conserved architecture of active or binding sites, or similar modes of oligomerization suggest a probable evolutionary ancestry.</p>
<p>These relationships can sometimes span over structural regions of different size, therefore we provide domain boundaries for both, family and superfamily levels.</p>
<p><span className="cl-level">Fold</span> groups superfamilies on the basis of the global structural features shared by the majority of their members. These features are the composition of the secondary structures in the domain core, their architecture and topology. Fold is an attribute of a superfamily but the constituent families of some superfamilies that have evolved distinct structural features can belong to a different fold.</p>
<p><span className="cl-level">IUPR</span> (Intrinsically Unstructured Protein Region) organises superfamilies of proteins or protein regions that do not adopt globular folded structure. Some of these proteins exists in ensemble of different conformations or are unstructured in free state but adopt an ordered conformation upon binding to other macromolecules.</p>
<p><span className="cl-level">Classes</span> bring together folds and IUPRs with different secondary structural content. These include all-alpha and all-beta proteins, containing predominantly alpha-helices and beta-strands, respectively, and ‘mixed’ alpha and beta classes (a/b) and (a+b) with respectively alternating and segregated alpha-helices and beta-strands, and the fifth class of small proteins with little or no secondary structures.</p>
<p><span className="cl-level">Protein type</span> groups folds and IUPRs into four groups: soluble, membrane, fibrous and intrinsically disordered. Each of these types to a large extent correlates with characteristic sequence and structural features.</p>

<p>
Each node in the SCOP classification can be uniquely identified by a seven digit identifier. The SCOP node identifiers will be stable across releases but may become obsolete if significant changes are introduced to the node.
</p>
<p>
The  SCOP database  is  built  as  a  classification  of  non-redundant  protein  domains.  A  representative is  selected  based  on  its  sequence  (UniProtKB)  and  structure  (PDB)  and  used  for  manual SCOP classification.  The  SCOP  domain  boundaries  are  assigned  to  both,  the  PDB  and  UniProtKB entry.  The  manual  classification  of  this  selected  representative  is  then  automatically  extended  to related  entries  using  SIFTS.
</p>
<div className="help-section">Usage</div>
<p>
We hope that SCOP will have broad utility that will attract a wide range of users. Experimental structural biologists may wish to explore the structures similar to their proteins of research, while theoreticians will likely find it most useful to browse the wide range of protein structural and evolutionary relationships or use it for benchmarking of prediction methods. Molecular biologists may find the classification helpful because the categorization assists in locating protein domains of interest on the entire protein. We also hope that SCOP will find pedagogical use, for it organizes and annotates structures in an easily comprehensible manner and makes them accessible over the web.
</p>
<div className="help-section">How to access SCOP data.</div>
<p>
The SCOP data can be accessed either by browsing or by searching. More details on how-to are provided below.
</p>
<div className="help-section">
  Using SCOP search box.
</div>
 <p>
To perform a search use the search box at the top right corner of the browser window or the main search box at the home page. The SCOP search engine allows queries with free text, PDB ID, UniProt ID, SCOP ID. If the search term contains two or more words, these have to be concatenated by % sign, e.g. binding%domain. The search is case-insensitive, but the order of the words is important.
</p>
<p>
If the search is with a free text, the search results are grouped and displayed for folds, superfamilies and families if any search hits are found. If the search is with PDB ID that is a representative, the search result lists the domains for this PDB entry. If the PDB entry is not a SCOP representative, then the search result shows the classification of the entry that represents the query PDB. In all instances, the search result provides a link to the page of the node that matches the search criteria. If the search matches description or name of family, superfamily or fold then a link to their pages is provided.  If the search match is a domain then a link to the domain page is provided. From the domain page you can navigate through the classification using the clickable ancestry chart.
</p>
<div className="help-section">
 Browsing SCOP.
</div>
<p>

When browsing SCOP, there are two ways of entry into the classification: by  structural class or by protein type. Each class and type page lists the corresponding folds and IUPRs. A small folder under the fold name allows to display its constituent nodes (superfamilies or families).
</p>
 <p>

The fold page provides the SCOP annotation for a given fold and lists the nodes that share this fold e.g. superfamily and/or family. Links are provided first for the constituent superfamilies and then for families if any exist. Under the superfamily name a small folder allows to display its constituent families. Next to the superfamily name is displayed the unique SCOP identifier for this node followed by a small icon that allows to view the structure of a superfamily domain that is selected to represent this superfamily.
</p>
 <p>

The superfamily page shows the annotation for a given SCOP superfamily. It lists the fold it belongs to and its constituent families. A link is provided to the predicted superfamily annotations in the SUPERFAMILY  database. At the bottom of the page is listed the representative superfamily domain information. The representative domains are listed on the left. Their boundaries are defined manually and are shown for both, the PDB and the UniProtKB entry. Links to external databases such as UniProtKB and PDB are provided as well as a link to the SCOP domain page. A small folder under the superfamily representative domain identifier allows to display the represented by this domain protein structures. Next to it, a small icon allows to view the structure of the representative domain.
</p>
 <p>

The SCOP family page has a similar to the superfamily page design. In addition to the common display features, a clickable ancestry chart allows to navigate through the SCOP classification. A link is provided to the Pfam database if the SCOP family correlates with the Pfam family.
</p>
 <p>

The SCOP representative domain page shows the details of its sequence and structure. A sequence viewer allows to allocate the SCOP domain on the entire  UniProtKB protein sequence as well as to retrieve all domains for this protein,  classified in SCOP. A click on another representative domain on the sequence viewer will reload the page for this domain. The structure of each representative SCOP domain is displayed within the context of a given PDB entry and coloured according to the colouring schema shown at the upper left corner of the structure widget. A clickable ancestry chart allows to explore the classification of the domain. A set of cross-links are provided to other databases and protein structure analysis and comparison tools.
</p>
 
 
<div className="help-section">
SCOP releases.
</div>
 <p>
SCOP is updated to include PDB and UniProtKB entries from the corresponding database releases, the release dates of which are listed on the SCOP <Link to={`${process.env.PUBLIC_URL}/stats`}>statistics page</Link>. SCOP does not provide classification for all PDB entries released before certain date. Across releases, some SCOP entries can become obsolete or change their boundaries depending on the changes within the PDB and UniProtKB databases.
</p>

 
<div className="help-section">
Linking to SCOP.
</div>
 
<p>

To link to the page for any node use the node identifier. Examples for a fold and a domain links are:
</p>
<p>
http://scop.mrc-lmb.cam.ac.uk/term/2000131
</p>
<p>
http://scop.mrc-lmb.cam.ac.uk/term/8003965
</p>
 
<div className="help-section">

SCOP download.
</div>
 <p>
The SCOP distributable files including the domain descriptions and classification and the SCOP representative domain sequences can be obtained from <Link to={`${process.env.PUBLIC_URL}/download`}>here</Link>. The SCOP classification expanded to the represented structures and residue-level cross-reference between PDB and UniProtKB entries for SCOP domains are available from European Bioinformatics Institute FTP site that provides access to data from <a href="ftp://ftp.ebi.ac.uk/pub/databases/msd/sifts/">SIFTS</a>. The residue-level cross-reference data is available in XML format.
</p>

<div className="help-section">

SCOP REST web-service.

 </div>
<p>
The new SCOP website is backed by a web service that provides access to the SCOP data using Representation State Transfer (REST) protocol.</p>
<p>The SCOP REST API enables fast, flexible and language agnostic programmatic access to the SCOP classification and SCOP domains. The data can be requested with simple HTTP requests and returned in JSON.
</p>
 
<p>
The service is accessible at <a href={restServer+"/"}>{restServer}</a>, and at the moment it provides the following endpoints:
</p>
 
<table className="rest-examples">
  <tbody>
    <tr>
      <th className="first">Resource</th><th>Description</th>
    </tr>
    <tr><td><a href={restServer+"/term/3000001"}>term/:scop_id</a></td><td>get all information about the classification term</td></tr>
    <tr><td><a href={restServer+"/domains/3000001"}>domains/:scop_id</a></td><td>get all domains classified at this node</td></tr>
    <tr><td><a href={restServer+"/ancestry/3000001"}>ancestry/:scop_id</a></td><td>get the ancestry graph of the term</td></tr>
    <tr><td><a href={restServer+"/stats"}>stats</a></td><td>latest release information</td></tr>
  </tbody>
</table>
<p>
Each datatype resides on a REST endpoint, these are all listed in the Endpoints section. A request is made to an endpoint as a parameterised HTTP request adhering to a predefined URI schema. Parameters can be required or optional. Optional parameters are indicated by being placed inside square brackets, e.g [ p = 1], in a documented endpoint. Other parameters are required and must be included in the URL. All parameters can be included as CGI style parameters as part of the HTTP request.
</p>
    </div>
    </div>);
}

function Contact() {
  return (
    <div className="page-content">
      <div className="page-title">Contact us</div>
      <div className="page-section">
        <div className="page-section-title">Contact us at scop2@mrc-lmb.cam.ac.uk</div>
      </div>
      <div className="page-section">
          User's feedback is very important to us. It can guide us in the future developments and database expansion. 
        </div>
        <div className="page-section">
          Please, get in touch with us if you have any comments and/or suggestions for improvement. 
        </div>
      </div>
  );
}
class Stats extends Component {

  constructor(props) {
    super(props);
  
    this.state = {
        data: {}
    }
  }

  componentDidMount() {
    const url = [restServer, 'stats'].join("/");
    //console.log(' fetch ', url);
    fetch(url)
        .then(response => response.json())
        .then(data =>  this.setState({ data: data}))
        .catch( e=> console.log(e));
  }

  render() {    
    let old_counts = {
      'folds'         : 1195,
      'superfamilies' : 1962,
      'families'      : 3902
    };

    if (!this.state.data.counts) {
      return (<></>)
    }
  
    let counts = this.state.data.counts;
    const sources = this.state.data.sources || [];
    const sa = Object.keys(sources).map( (k) => (
      {"k": k.split('.')[0], "v":sources[k]}
    ));


  
    //console.log(sources);
    //console.log(sa);
    return (
      <div className="stats-table">
        <h3>Statistics</h3>
        <Table striped bordered>
        <thead>
          <tr>
            <th> </th>
            <th className="st-number"> SCOP2 </th>
            <th className="st-number"> SCOP 1.75 </th>
          </tr>
        </thead>
        <tbody>
        {
          counts.map( (item) => (
            <tr key={"st_"+item[0]}>
              <td className="st-string"> Number of { item[0] } </td>
              <td className="st-number"> { item[1] } </td>
              <td className="st-number"> { old_counts[item[0]] || "n.a" } </td>
            </tr>
          ))
        }
        </tbody>
        </Table>
        
        <div className="stats-note">
        <i>SCOP has been updated to include entries from the following releases:</i>
        <Table className="stats-sources">
        { 
          sa.map( (item)=> (
            <tr className="stats-item" key={item.k}><td>{item.k}</td><td>{item.v}</td></tr>
          )) 
        } 
        </Table>
        </div>
        
      </div>
    );
  }
}

